<template>
    <div class="footer-social-links">
        <div class="divider-social">
            <div class="line"></div>
            <div><span class="call-to-social">Or continue with</span></div>
            <div class="line"></div>
        </div>
        <div class="social-media">
            <div class="social-link" v-for="link in loginLinks" :key="link.name">
                <a :href="link.href">
                    <img :src="link.img" alt="inst" />
                </a>
                <span class="social-name">{{ link.name }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FooterPart',
        data() {
            return {
                loginLinks: [
                    /* TODO: fix social providers auth and uncomment below **/
                    // {
                    //     name: 'Instagram',
                    //     href: '/login/instagram',
                    //     img: '/images/InstagramNegative.png'
                    // },
                    // {
                    //     name: 'Facebook',
                    //     href: '/login/facebook',
                    //     img: '/images/FacebookNegative.png'
                    // },
                    {
                        name: 'Google',
                        href: '/login/google',
                        img: '/images/GoogleNegative.png'
                    }
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    @media screen and (max-width: 600px) {
        .social-link:nth-child(4) {
            margin-left: auto;
            margin-right: auto;
        }
    }
    .footer-social-links {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        min-width: 100%;
        gap: 24px;
    }
    .call-to-social {
        color: #acacac;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%;
    }

    .line {
        display: flex;
        flex: 1;
        border: 1px solid #acacac;
    }

    .social-media {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 48px;
        flex-wrap: wrap;
    }

    .social-link {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
    }
    .divider-social {
        display: flex;
        align-items: center;
        min-width: 100%;
        gap: 35px;
    }
    .social-name {
        color: #dedede;
        text-align: center;
        font-family: Instrument Sans;
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
    }
</style>
